import {
  FormattedString,
  InfoBlock,
  InfoBlockLayout,
  InfoBlockStatus,
  InputFormCallout,
  InputFormCalloutProps,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { CloudVmClusterAvailableCapacity } from "../../gen/clients/mchub-azure-api-client-exa";
import { IntegerInput } from "../IntegerInput/IntegerInput";

export const enum Fields {
  NodeCount = "nodeCount",
  StorageSize = "storageSize",
}
export interface AddCapacityVmClusterProps extends
  Omit<InputFormCalloutProps, "children">
{
  availableCapacity: CloudVmClusterAvailableCapacity | undefined;
}

export const AddCapacityVmCluster = ({ availableCapacity, ...rest }: AddCapacityVmClusterProps): JSX.Element => {
  const availableNodeCount = availableCapacity?.availableComputeCount;
  const availableStorageSize = availableCapacity?.availableStorageSizeInGBs;

  const message = (): string => {
    let infoMessage = "";
    if (availableNodeCount && availableStorageSize) {
      infoMessage = Messages.hints.vmClusterAvailableCapacity(`${availableNodeCount}`, `${availableStorageSize}`);
    }
    if (availableNodeCount && !availableStorageSize) {
      infoMessage = Messages.hints.vmClusterAvailableCapacityForNodeCount(`${availableNodeCount}`);
    }
    if (!availableNodeCount && availableStorageSize) {
      infoMessage = Messages.hints.vmClusterAvailableCapacityForStorage(`${availableStorageSize}`);
    }
    return infoMessage;
  };

  return (
    <InputFormCallout {...rest}>
      <IntegerInput
        label={Messages.labels.additionalNodeCount()}
        fieldName={Fields.NodeCount}
        defaultValue={0}
        min={0}
        max={availableNodeCount}
        disabled={!availableNodeCount}
      />
      <IntegerInput
        label={Messages.labels.additionalStorageInGB()}
        fieldName={Fields.StorageSize}
        defaultValue={0}
        min={0}
        max={availableStorageSize}
        disabled={!availableStorageSize}
      />
      <InfoBlock
        message={(FormattedString({ inputText: message() }) as unknown as string)}
        messageType={InfoBlockStatus.INFO}
        infoLayout={InfoBlockLayout.Compact}
        customInfoStyle={{ root: { marginBottom: "15px" } }}
      />
    </InputFormCallout>
  );
};
